import { Button, ButtonProps } from '@cmpsr/components';

export default function CancelRenewalAction({ onClick }: ButtonProps) {
  return (
    <Button onClick={onClick} size="s" variant="link-destroy" color="text-error" justifyContent="flex-start">
      Cancel renewal
    </Button>
  );
}
